var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-checkbox"},[_c('a-checkbox',{attrs:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }